import { get } from './base'
import { InventoryType, type InventoryTypeJson } from '@ironsight/types'

const endpoint = '/api/v2/assets'

export function getAllInventoryTypes(signal?: AbortSignal) {
  const inventoryTypes = get<InventoryTypeJson[]>(endpoint, { signal }).then((response) =>
    response.data.map((json) => new InventoryType(json)),
  )
  return inventoryTypes
}
